import React from 'react'
import styled from 'styled-components'
import { NavOverlay, LogoLink, HamburgerButton, Menu, Button } from '@streamr/streamr-layout'
import { TABLET } from '@streamr/streamr-layout/styled'
import { AppsAndServicesGroup, CaseStudiesGroup, ProjectMenu, DevelopersMenu } from './Nav'
import Display from '~shared/Display'
import Link from '~shared/Link'
import Navbar from '~shared/Navbar'
import urls from '~utils/urls'

const MenuInner = styled.div`
    display: flex;
    width: 100%;
`

const MenuColumn = styled.div`
    flex: 0 0 50%;

    @media (min-width: ${TABLET}px) {
        flex: 0 0 160px;

        & + & {
            margin-left: 96px;
        }
    }
`

const MobileNav = () => (
    <Display as={NavOverlay} desktop="none">
        <NavOverlay.Head>
            <Navbar>
                <Navbar.Item spread>
                    {/* Preserve the space taken by the above logo. */}
                    <LogoLink as="div">
                        <svg viewBox="0 0 1 1" xmlns="http://www.w3.org/2000/svg" />
                    </LogoLink>
                </Navbar.Item>
                <Navbar.Item>
                    <HamburgerButton />
                </Navbar.Item>
            </Navbar>
        </NavOverlay.Head>
        <NavOverlay.Body>
            <NavOverlay.Link as={Link} href={urls.top}>
                Top
            </NavOverlay.Link>
            <NavOverlay.Dropdown label="Discover">
                <Menu>
                    <MenuInner>
                        <MenuColumn>
                            <AppsAndServicesGroup />
                        </MenuColumn>
                        <MenuColumn>
                            <CaseStudiesGroup />
                        </MenuColumn>
                    </MenuInner>
                </Menu>
            </NavOverlay.Dropdown>
            <NavOverlay.Dropdown label="Project">
                <ProjectMenu />
            </NavOverlay.Dropdown>
            <NavOverlay.Dropdown label="Developers">
                <DevelopersMenu />
            </NavOverlay.Dropdown>
            <NavOverlay.Dropdown label="Community">
                <Menu>
                    <MenuInner>
                        <MenuColumn>
                            <Menu.Item as={Link} newTab href={urls.community.discord}>
                                Discord
                            </Menu.Item>
                            <Menu.Item as={Link} newTab href={urls.community.twitter}>
                                Twitter
                            </Menu.Item>
                            <Menu.Item as={Link} newTab href={urls.community.github}>
                                Github
                            </Menu.Item>
                            <Menu.Item as={Link} newTab href={urls.community.youtube}>
                                Youtube
                            </Menu.Item>
                        </MenuColumn>
                        <MenuColumn>
                            <Menu.Item as={Link} newTab href={urls.community.reddit}>
                                Reddit
                            </Menu.Item>
                            <Menu.Item as={Link} newTab href={urls.community.blog}>
                                Blog
                            </Menu.Item>
                            <Menu.Item as={Link} newTab href={urls.community.linkedIn}>
                                Linkedin
                            </Menu.Item>
                            <Menu.Item as={Link} newTab href={urls.community.trello}>
                                Trello
                            </Menu.Item>
                        </MenuColumn>
                    </MenuInner>
                </Menu>
            </NavOverlay.Dropdown>
            <NavOverlay.Dropdown label="Contact">
                <Menu>
                    <Menu.Item as={Link} href={urls.contact.general}>
                        General
                    </Menu.Item>
                    <Menu.Item as={Link} href={urls.contact.media}>
                        Media
                    </Menu.Item>
                    <Menu.Item as={Link} href={urls.contact.jobs}>
                        Jobs
                    </Menu.Item>
                    <Menu.Item as={Link} href={urls.contact.business}>
                        Business
                    </Menu.Item>
                </Menu>
            </NavOverlay.Dropdown>
            <NavOverlay.Dropdown label="Documents">
                <Menu>
                    <Menu.Item as={Link} href={urls.documents.governanceWhitepaper}>
                        Decentralized governance
                    </Menu.Item>
                    <Menu.Item as={Link} href={urls.documents.whitepaper}>
                        Streamr Whitepaper
                    </Menu.Item>
                    <Menu.Item as={Link} href={urls.documents.terms}>
                        Terms &amp; Conditions
                    </Menu.Item>
                    <Menu.Item as={Link} href={urls.documents.privacy}>
                        Privacy policy
                    </Menu.Item>
                </Menu>
            </NavOverlay.Dropdown>
        </NavOverlay.Body>
        <NavOverlay.Footer>
            <Button
                tag="a"
                kind="primary"
                size="big"
                href="/core"
            >
                Use Core
            </Button>
        </NavOverlay.Footer>
    </Display>
)

export default MobileNav
